Vue.component('ack-validation-resins', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-validation-resins',
    mixins: [languageMixins],
    created() {
        this.loadCodepenScript()
    },
    mounted() {
      appLog.log('ack-validation-resins mounted')
      this.setPageIsLoading(false)
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }
      
    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']), 
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'validation-resins-page',
        validationInfo: {
          title_section:{
            title:'Compatible Resins for Ackuretta 3D Printing Solution',
            description: "Discover the perfect materials for your Ackuretta 3D Printing Solutions. We work closely with resin manufacturers to validate their products, ensuring optimal performance and quality. Below, you’ll find our continuously updated list of compatible resins, all approved for use with Ackuretta devices. Choose with confidence and elevate your digital dentistry workflow.",
            image_desktop: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Compatible_Resins_Page_Banner.jpg?v=1722852489',
            image_mobile: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Compatible_Resins_Page_Banner.jpg?v=1722852489',
          }
        }
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading']),
      //...Vuex.mapActions('sliders', ['getSlideList'])
      loadCodepenScript() {
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://assets.codepen.io/assets/embed/ei.js'
        document.body.appendChild(script)
      }
    },
    beforeDestroy() {
    },
    watch: {
      
      data1: {
        handler() {
          
          
          
        },
        deep: false
      }
    }
  })